import { forwardRef } from "react";
import { Swiper, SwiperSlide, SwiperProps } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { merge, map } from "lodash-es";
import { goToPageV2, debounce, NativeByUrlList } from "@/utils/common";
import "swiper/css";
import "swiper/css/pagination";
import styles from "./style.module.less";
import { getChannel } from "@/utils/tools";
import { trackGdp } from "@/utils/gio-report";

const DEFAULT_CONFIG = {
  // centeredSlides: true, // 移动端常见居中模式
  touchStartPreventDefault: false, // 是否允许原生滚动
  loop: true,
  autoplay: {
    delay: 3000,
    pauseOnMouseEnter: true,
    disableOnInteraction: false,
  },
  pagination: {
    clickable: true,
    type: "bullets",
    bulletClass: "swiper-pagination-bullet",
    bulletActiveClass: "swiper-pagination-bullet-active",
    modifierClass: "swiper-pagination-",
  },
  modules: [Autoplay, Pagination], // 4. 注册Pagination模块
};

type Props = {
  config?: SwiperProps;
  imgs: Array<{
    key: number | string | symbol;
    src: string;
    link: string;
    jumpUrlMap?: Record<string, string>;
  }>;
  activityInfo: {
    pageCode: string;
    versionCode: string;
    moduleId: string;
    moduleRemark: string;
    moduleType: string;
    connectedActivitiesId: string;
  };
};
const ImgSwiper = forwardRef<HTMLLIElement, Props>((props, ref) => {
  const { config, imgs, activityInfo } = props;

  const mergedConfig = merge(DEFAULT_CONFIG, config);

  const goPage = debounce((item: any, index: any) => {
    if (item?.jumpUrlMap) {
      NativeByUrlList(item.jumpUrlMap);
    } else {
      // 兜底使用旧的 url 格式
      if (item.link.includes(window.location.origin)) {
        console.log("window.location.origin");
        window.location.href = item.link;
      } else {
        goToPageV2({ url: item.link });
      }
    }

    trackGdp("P20189", "B004", {
      trackName: "充电_营销专题页_组件点击",
      origin: getChannel(),
      userType: "",
      versionId: activityInfo.versionCode,
      pageId: activityInfo.pageCode,
      ComponentCode: activityInfo.moduleId,
      description: activityInfo.moduleRemark,
      type: activityInfo.moduleType,
      activityId: activityInfo.connectedActivitiesId,
      clickLocation: "轮播图点击-" + (index + 1),
    });
  }, 500);

  return (
    <div className={styles["xply-image-swiper"]}>
      <Swiper ref={ref} {...mergedConfig}>
        {/* 5. 添加分页器DOM结构 */}
        <div
          slot="container-start"
          className={styles["swiper-pagination"]}
        ></div>
        {map(imgs, (item, index) => (
          <SwiperSlide key={item.key} onClick={() => goPage(item, index)}>
            <img src={item.src} alt="" style={{ width: "100%" }} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
});

export default ImgSwiper;
